import * as Types from '../../../schema/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateProductGroupWithProductMutationVariables = Types.Exact<{
  productGroupData: Types.CreateProductGroupInputGraphqlType;
}>;


export type CreateProductGroupWithProductMutation = { __typename?: 'Mutation', adminCreateProductGroupWithProduct: { __typename?: 'ProductGroupOutputGraphqlType', productGroup: { __typename?: 'ProductGroupGraphqlType', id: number } } };

export type UppermostCategoriesQueryVariables = Types.Exact<{
  pagination?: Types.InputMaybe<Types.Pagination>;
}>;


export type UppermostCategoriesQuery = { __typename?: 'Query', adminUppermostCategories: { __typename?: 'UppermostCategoryPageGraphqlType', edges: Array<{ __typename?: 'PaginatedUppermostCategoryGraphqlTypeEdge', node: { __typename?: 'UppermostCategoryGraphqlType', id: number, name: string } }> } };

export type UpperCategoriesQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.UpperCategoryFilterQuery>;
  pagination?: Types.InputMaybe<Types.Pagination>;
}>;


export type UpperCategoriesQuery = { __typename?: 'Query', adminUpperCategories: { __typename?: 'UpperCategoryPageGraphqlType', edges: Array<{ __typename?: 'PaginatedUpperCategoryGraphqlTypeEdge', node: { __typename?: 'UpperCategoryGraphqlType', name: string, id: number, uppermostCategoryId: number } }> } };

export type CategoriesQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.CategoryFilterQuery>;
  pagination?: Types.InputMaybe<Types.Pagination>;
}>;


export type CategoriesQuery = { __typename?: 'Query', adminCategories: { __typename?: 'CategoryPageGraphqlType', edges: Array<{ __typename?: 'PaginatedCategoryGraphqlTypeEdge', node: { __typename?: 'CategoryGraphqlType', name: string, upperCategoryId: number, id: number } }> } };

export type DeliveryCompaniesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type DeliveryCompaniesQuery = { __typename?: 'Query', adminDeliveryCompanies: Array<{ __typename?: 'DeliveryCompanyGraphqlType', code: string, id: number, international: boolean, name: string }> };

export type ProductsQueryVariables = Types.Exact<{
  order?: Types.InputMaybe<Types.Scalars['Order']['input']>;
  filter: Types.ProductFilterQuery;
}>;


export type ProductsQuery = { __typename?: 'Query', adminProducts?: { __typename?: 'ProductPageGraphqlType', edges: Array<{ __typename?: 'PaginatedProductGraphqlTypeEdge', node: { __typename?: 'ProductGraphqlType', businessInHouseMargin: number, businessInHouseMarginRate: number, businessSellerMargin: number, businessSellerMarginRate: number, businessSellerSupplyPrice: number, code: string, description?: string | null, freelanceInHouseMargin: number, freelanceInHouseMarginRate: number, freelanceSellerMargin: number, freelanceSellerMarginRate: number, freelanceSellerSupplyPrice: number, id: number, inHousePurchasePrice: number, isPrimary: boolean, jointPurchasePrice: number, name: string, note?: string | null, onlineLowestPrice?: number | null, retailPrice: number, taxType: Types.ETaxType, useType: Types.EProductUseType, items?: Array<{ __typename?: 'ItemGraphqlType', id: number, name: string, stock?: number | null }> | null } }> } | null };

export type ItemsQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.ItemFilterQuery>;
  pagination?: Types.InputMaybe<Types.Pagination>;
}>;


export type ItemsQuery = { __typename?: 'Query', adminItems: { __typename?: 'ItemPageGraphqlType', pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null, startCursor?: string | null } | null, edges: Array<{ __typename?: 'PaginatedItemGraphqlTypeEdge', cursor: string, node: { __typename?: 'ItemGraphqlType', id: number, name: string, stock?: number | null, code: string, productGroupNames?: Array<string> | null, isInfinityStock: boolean } }> } };

export type DeleteProductGroupMutationVariables = Types.Exact<{
  adminDeleteProductGroupId: Types.Scalars['Int']['input'];
}>;


export type DeleteProductGroupMutation = { __typename?: 'Mutation', adminDeleteProductGroup: { __typename?: 'ProductGroupGraphqlType', id: number } };

export type UpdateProductGroupWithProductMutationVariables = Types.Exact<{
  adminUpdateProductGroupWithProductId: Types.Scalars['Int']['input'];
  productGroupData: Types.UpdateProductGroupInputGraphqlType;
}>;


export type UpdateProductGroupWithProductMutation = { __typename?: 'Mutation', adminUpdateProductGroupWithProduct: { __typename?: 'ProductGroupOutputGraphqlType', productGroup: { __typename?: 'ProductGroupGraphqlType', id: number } } };

export type ProductGroupQueryVariables = Types.Exact<{
  adminProductGroupId: Types.Scalars['Int']['input'];
}>;


export type ProductGroupQuery = { __typename?: 'Query', adminProductGroup: { __typename?: 'ProductGroupGraphqlType', brandId: number, additionalFee?: number | null, categoryId: number, deliveryCompanyCode?: string | null, deliveryCompanyName?: string | null, deliveryFee?: number | null, deliveryFeeType: Types.EProductGroupDeliveryFeeType, exchangeFee?: number | null, freeDeliveryConditionFee?: number | null, id: number, isPurchaseQuantityLimit: boolean, isRegionFee: boolean, jejuIslandFee?: number | null, managerId: number, name: string, note?: string | null, notice?: string | null, productUrl?: string | null, productUsp?: string | null, purchaseQuantityLimit?: number | null, releaseTime?: string | null, releaseType: Types.EProductGroupReleaseType, returnFee?: number | null, sampleSupport?: string | null, updatedAt: string, vendorId: number, status: Types.EProductGroupStatus, productGroupType: Types.EProductGroupType, category: { __typename?: 'ProductGroupCategoryGraphqlType', categoryName: string, upperCategoryName: string, uppermostCategoryName: string, categoryId: number, upperCategoryId: number, uppermostCategoryId: number }, products: Array<{ __typename?: 'ProductGraphqlType', businessInHouseMargin: number, businessInHouseMarginRate: number, businessSellerMargin: number, businessSellerMarginRate: number, businessSellerSupplyPrice: number, code: string, description?: string | null, freelanceInHouseMargin: number, freelanceInHouseMarginRate: number, freelanceSellerMargin: number, freelanceSellerMarginRate: number, freelanceSellerSupplyPrice: number, id: number, inHousePurchasePrice: number, isAdditionalProduct: boolean, isPrimary: boolean, jointPurchasePrice: number, name: string, note?: string | null, onlineLowestPrice?: number | null, retailPrice: number, taxType: Types.ETaxType, useType: Types.EProductUseType, items?: Array<{ __typename?: 'ItemGraphqlType', code: string, id: number, isInfinityStock: boolean, name: string, productGroupNames?: Array<string> | null, stock?: number | null }> | null }>, multimedia: Array<{ __typename?: 'ProductGroupMultimediaGraphqlType', url: string, multimediaType: Types.EProductGroupMultimediaType, useType: Types.EProductGroupMultimediaUseType }>, vendor: { __typename?: 'VendorGraphqlType', name: string }, brand: { __typename?: 'BrandGraphqlType', name: string }, markets?: Array<{ __typename?: 'MarketGraphqlType', name: string, endedAt?: string | null, startedAt: string, status: Types.EMarketStatus }> | null } };

export type PatchProductGroupMutationVariables = Types.Exact<{
  input: Types.PatchProductGroupGraphqlInputType;
}>;


export type PatchProductGroupMutation = { __typename?: 'Mutation', adminPatchProductGroup: { __typename?: 'ProductGroupGraphqlType', id: number } };

export type BrandsInProductGroupQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.AdminListBrandsPageQueryFilter>;
}>;


export type BrandsInProductGroupQuery = { __typename?: 'Query', adminBrands: { __typename?: 'BrandPageGraphqlType', edges: Array<{ __typename?: 'PaginatedBrandGraphqlTypeEdge', node: { __typename?: 'BrandGraphqlType', name: string, id: number } }> } };

export type CreateTemporaryProductMutationVariables = Types.Exact<{
  input: Types.CreateTemporaryProductGraphqlInput;
}>;


export type CreateTemporaryProductMutation = { __typename?: 'Mutation', adminCreateTemporaryProduct: { __typename?: 'CreateTemporaryProductPayload', temporaryProduct: { __typename?: 'TemporaryProductGraphqlType', id: number } } };

export type UpdateTemporaryProductMutationVariables = Types.Exact<{
  input: Types.UpdateTemporaryProductGraphqlInput;
}>;


export type UpdateTemporaryProductMutation = { __typename?: 'Mutation', adminUpdateTemporaryProduct: { __typename?: 'UpdateTemporaryProductPayload', temporaryProduct: { __typename?: 'TemporaryProductGraphqlType', id: number } } };

export type TemporaryProductQueryVariables = Types.Exact<{
  adminTemporaryProductId: Types.Scalars['Int']['input'];
}>;


export type TemporaryProductQuery = { __typename?: 'Query', adminTemporaryProduct: { __typename?: 'TemporaryProductGraphqlType', json: string, id: number } };

export type DeleteTemporaryProductMutationVariables = Types.Exact<{
  adminDeleteTemporaryProductId: Types.Scalars['Int']['input'];
}>;


export type DeleteTemporaryProductMutation = { __typename?: 'Mutation', adminDeleteTemporaryProduct: { __typename?: 'DeleteTemporaryProductPayload', id: number } };


export const CreateProductGroupWithProductDocument = gql`
    mutation CreateProductGroupWithProduct($productGroupData: CreateProductGroupInputGraphqlType!) {
  adminCreateProductGroupWithProduct(productGroupData: $productGroupData) {
    productGroup {
      id
    }
  }
}
    `;
export type CreateProductGroupWithProductMutationFn = Apollo.MutationFunction<CreateProductGroupWithProductMutation, CreateProductGroupWithProductMutationVariables>;

/**
 * __useCreateProductGroupWithProductMutation__
 *
 * To run a mutation, you first call `useCreateProductGroupWithProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductGroupWithProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductGroupWithProductMutation, { data, loading, error }] = useCreateProductGroupWithProductMutation({
 *   variables: {
 *      productGroupData: // value for 'productGroupData'
 *   },
 * });
 */
export function useCreateProductGroupWithProductMutation(baseOptions?: Apollo.MutationHookOptions<CreateProductGroupWithProductMutation, CreateProductGroupWithProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProductGroupWithProductMutation, CreateProductGroupWithProductMutationVariables>(CreateProductGroupWithProductDocument, options);
      }
export type CreateProductGroupWithProductMutationHookResult = ReturnType<typeof useCreateProductGroupWithProductMutation>;
export type CreateProductGroupWithProductMutationResult = Apollo.MutationResult<CreateProductGroupWithProductMutation>;
export type CreateProductGroupWithProductMutationOptions = Apollo.BaseMutationOptions<CreateProductGroupWithProductMutation, CreateProductGroupWithProductMutationVariables>;
export const UppermostCategoriesDocument = gql`
    query UppermostCategories($pagination: Pagination) {
  adminUppermostCategories(pagination: $pagination) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useUppermostCategoriesQuery__
 *
 * To run a query within a React component, call `useUppermostCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUppermostCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUppermostCategoriesQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useUppermostCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<UppermostCategoriesQuery, UppermostCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UppermostCategoriesQuery, UppermostCategoriesQueryVariables>(UppermostCategoriesDocument, options);
      }
export function useUppermostCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UppermostCategoriesQuery, UppermostCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UppermostCategoriesQuery, UppermostCategoriesQueryVariables>(UppermostCategoriesDocument, options);
        }
export type UppermostCategoriesQueryHookResult = ReturnType<typeof useUppermostCategoriesQuery>;
export type UppermostCategoriesLazyQueryHookResult = ReturnType<typeof useUppermostCategoriesLazyQuery>;
export type UppermostCategoriesQueryResult = Apollo.QueryResult<UppermostCategoriesQuery, UppermostCategoriesQueryVariables>;
export const UpperCategoriesDocument = gql`
    query UpperCategories($filter: UpperCategoryFilterQuery, $pagination: Pagination) {
  adminUpperCategories(filter: $filter, pagination: $pagination) {
    edges {
      node {
        name
        id
        uppermostCategoryId
      }
    }
  }
}
    `;

/**
 * __useUpperCategoriesQuery__
 *
 * To run a query within a React component, call `useUpperCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpperCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpperCategoriesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useUpperCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<UpperCategoriesQuery, UpperCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UpperCategoriesQuery, UpperCategoriesQueryVariables>(UpperCategoriesDocument, options);
      }
export function useUpperCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UpperCategoriesQuery, UpperCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UpperCategoriesQuery, UpperCategoriesQueryVariables>(UpperCategoriesDocument, options);
        }
export type UpperCategoriesQueryHookResult = ReturnType<typeof useUpperCategoriesQuery>;
export type UpperCategoriesLazyQueryHookResult = ReturnType<typeof useUpperCategoriesLazyQuery>;
export type UpperCategoriesQueryResult = Apollo.QueryResult<UpperCategoriesQuery, UpperCategoriesQueryVariables>;
export const CategoriesDocument = gql`
    query Categories($filter: CategoryFilterQuery, $pagination: Pagination) {
  adminCategories(filter: $filter, pagination: $pagination) {
    edges {
      node {
        name
        upperCategoryId
        id
      }
    }
  }
}
    `;

/**
 * __useCategoriesQuery__
 *
 * To run a query within a React component, call `useCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoriesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<CategoriesQuery, CategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategoriesQuery, CategoriesQueryVariables>(CategoriesDocument, options);
      }
export function useCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategoriesQuery, CategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategoriesQuery, CategoriesQueryVariables>(CategoriesDocument, options);
        }
export type CategoriesQueryHookResult = ReturnType<typeof useCategoriesQuery>;
export type CategoriesLazyQueryHookResult = ReturnType<typeof useCategoriesLazyQuery>;
export type CategoriesQueryResult = Apollo.QueryResult<CategoriesQuery, CategoriesQueryVariables>;
export const DeliveryCompaniesDocument = gql`
    query DeliveryCompanies {
  adminDeliveryCompanies {
    code
    id
    international
    name
  }
}
    `;

/**
 * __useDeliveryCompaniesQuery__
 *
 * To run a query within a React component, call `useDeliveryCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeliveryCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeliveryCompaniesQuery({
 *   variables: {
 *   },
 * });
 */
export function useDeliveryCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<DeliveryCompaniesQuery, DeliveryCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeliveryCompaniesQuery, DeliveryCompaniesQueryVariables>(DeliveryCompaniesDocument, options);
      }
export function useDeliveryCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeliveryCompaniesQuery, DeliveryCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeliveryCompaniesQuery, DeliveryCompaniesQueryVariables>(DeliveryCompaniesDocument, options);
        }
export type DeliveryCompaniesQueryHookResult = ReturnType<typeof useDeliveryCompaniesQuery>;
export type DeliveryCompaniesLazyQueryHookResult = ReturnType<typeof useDeliveryCompaniesLazyQuery>;
export type DeliveryCompaniesQueryResult = Apollo.QueryResult<DeliveryCompaniesQuery, DeliveryCompaniesQueryVariables>;
export const ProductsDocument = gql`
    query Products($order: Order, $filter: ProductFilterQuery!) {
  adminProducts(order: $order, filter: $filter) {
    edges {
      node {
        businessInHouseMargin
        businessInHouseMarginRate
        businessSellerMargin
        businessSellerMarginRate
        businessSellerSupplyPrice
        code
        description
        freelanceInHouseMargin
        freelanceInHouseMarginRate
        freelanceSellerMargin
        freelanceSellerMarginRate
        freelanceSellerSupplyPrice
        id
        inHousePurchasePrice
        isPrimary
        items {
          id
          name
          stock
        }
        jointPurchasePrice
        name
        note
        onlineLowestPrice
        retailPrice
        taxType
        useType
      }
    }
  }
}
    `;

/**
 * __useProductsQuery__
 *
 * To run a query within a React component, call `useProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsQuery({
 *   variables: {
 *      order: // value for 'order'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useProductsQuery(baseOptions: Apollo.QueryHookOptions<ProductsQuery, ProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductsQuery, ProductsQueryVariables>(ProductsDocument, options);
      }
export function useProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductsQuery, ProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductsQuery, ProductsQueryVariables>(ProductsDocument, options);
        }
export type ProductsQueryHookResult = ReturnType<typeof useProductsQuery>;
export type ProductsLazyQueryHookResult = ReturnType<typeof useProductsLazyQuery>;
export type ProductsQueryResult = Apollo.QueryResult<ProductsQuery, ProductsQueryVariables>;
export const ItemsDocument = gql`
    query Items($filter: ItemFilterQuery, $pagination: Pagination) {
  adminItems(filter: $filter, pagination: $pagination) {
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    edges {
      cursor
      node {
        id
        name
        stock
        code
        productGroupNames
        isInfinityStock
      }
    }
  }
}
    `;

/**
 * __useItemsQuery__
 *
 * To run a query within a React component, call `useItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useItemsQuery(baseOptions?: Apollo.QueryHookOptions<ItemsQuery, ItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemsQuery, ItemsQueryVariables>(ItemsDocument, options);
      }
export function useItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemsQuery, ItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemsQuery, ItemsQueryVariables>(ItemsDocument, options);
        }
export type ItemsQueryHookResult = ReturnType<typeof useItemsQuery>;
export type ItemsLazyQueryHookResult = ReturnType<typeof useItemsLazyQuery>;
export type ItemsQueryResult = Apollo.QueryResult<ItemsQuery, ItemsQueryVariables>;
export const DeleteProductGroupDocument = gql`
    mutation DeleteProductGroup($adminDeleteProductGroupId: Int!) {
  adminDeleteProductGroup(id: $adminDeleteProductGroupId) {
    id
  }
}
    `;
export type DeleteProductGroupMutationFn = Apollo.MutationFunction<DeleteProductGroupMutation, DeleteProductGroupMutationVariables>;

/**
 * __useDeleteProductGroupMutation__
 *
 * To run a mutation, you first call `useDeleteProductGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductGroupMutation, { data, loading, error }] = useDeleteProductGroupMutation({
 *   variables: {
 *      adminDeleteProductGroupId: // value for 'adminDeleteProductGroupId'
 *   },
 * });
 */
export function useDeleteProductGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProductGroupMutation, DeleteProductGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProductGroupMutation, DeleteProductGroupMutationVariables>(DeleteProductGroupDocument, options);
      }
export type DeleteProductGroupMutationHookResult = ReturnType<typeof useDeleteProductGroupMutation>;
export type DeleteProductGroupMutationResult = Apollo.MutationResult<DeleteProductGroupMutation>;
export type DeleteProductGroupMutationOptions = Apollo.BaseMutationOptions<DeleteProductGroupMutation, DeleteProductGroupMutationVariables>;
export const UpdateProductGroupWithProductDocument = gql`
    mutation UpdateProductGroupWithProduct($adminUpdateProductGroupWithProductId: Int!, $productGroupData: UpdateProductGroupInputGraphqlType!) {
  adminUpdateProductGroupWithProduct(
    id: $adminUpdateProductGroupWithProductId
    productGroupData: $productGroupData
  ) {
    productGroup {
      id
    }
  }
}
    `;
export type UpdateProductGroupWithProductMutationFn = Apollo.MutationFunction<UpdateProductGroupWithProductMutation, UpdateProductGroupWithProductMutationVariables>;

/**
 * __useUpdateProductGroupWithProductMutation__
 *
 * To run a mutation, you first call `useUpdateProductGroupWithProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductGroupWithProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductGroupWithProductMutation, { data, loading, error }] = useUpdateProductGroupWithProductMutation({
 *   variables: {
 *      adminUpdateProductGroupWithProductId: // value for 'adminUpdateProductGroupWithProductId'
 *      productGroupData: // value for 'productGroupData'
 *   },
 * });
 */
export function useUpdateProductGroupWithProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductGroupWithProductMutation, UpdateProductGroupWithProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductGroupWithProductMutation, UpdateProductGroupWithProductMutationVariables>(UpdateProductGroupWithProductDocument, options);
      }
export type UpdateProductGroupWithProductMutationHookResult = ReturnType<typeof useUpdateProductGroupWithProductMutation>;
export type UpdateProductGroupWithProductMutationResult = Apollo.MutationResult<UpdateProductGroupWithProductMutation>;
export type UpdateProductGroupWithProductMutationOptions = Apollo.BaseMutationOptions<UpdateProductGroupWithProductMutation, UpdateProductGroupWithProductMutationVariables>;
export const ProductGroupDocument = gql`
    query ProductGroup($adminProductGroupId: Int!) {
  adminProductGroup(id: $adminProductGroupId) {
    brandId
    additionalFee
    categoryId
    category {
      categoryName
      upperCategoryName
      uppermostCategoryName
      categoryId
      upperCategoryId
      uppermostCategoryId
    }
    deliveryCompanyCode
    deliveryCompanyName
    deliveryFee
    deliveryFeeType
    exchangeFee
    freeDeliveryConditionFee
    id
    isPurchaseQuantityLimit
    isRegionFee
    jejuIslandFee
    managerId
    name
    note
    notice
    productUrl
    productUsp
    purchaseQuantityLimit
    releaseTime
    releaseType
    returnFee
    sampleSupport
    updatedAt
    vendorId
    status
    productGroupType
    products {
      businessInHouseMargin
      businessInHouseMarginRate
      businessSellerMargin
      businessSellerMarginRate
      businessSellerSupplyPrice
      code
      description
      freelanceInHouseMargin
      freelanceInHouseMarginRate
      freelanceSellerMargin
      freelanceSellerMarginRate
      freelanceSellerSupplyPrice
      id
      inHousePurchasePrice
      isAdditionalProduct
      isPrimary
      items {
        code
        id
        isInfinityStock
        name
        productGroupNames
        stock
      }
      jointPurchasePrice
      name
      note
      onlineLowestPrice
      retailPrice
      taxType
      useType
    }
    multimedia {
      url
      multimediaType
      useType
    }
    vendor {
      name
    }
    brand {
      name
    }
    markets {
      name
      endedAt
      startedAt
      status
    }
  }
}
    `;

/**
 * __useProductGroupQuery__
 *
 * To run a query within a React component, call `useProductGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductGroupQuery({
 *   variables: {
 *      adminProductGroupId: // value for 'adminProductGroupId'
 *   },
 * });
 */
export function useProductGroupQuery(baseOptions: Apollo.QueryHookOptions<ProductGroupQuery, ProductGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductGroupQuery, ProductGroupQueryVariables>(ProductGroupDocument, options);
      }
export function useProductGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductGroupQuery, ProductGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductGroupQuery, ProductGroupQueryVariables>(ProductGroupDocument, options);
        }
export type ProductGroupQueryHookResult = ReturnType<typeof useProductGroupQuery>;
export type ProductGroupLazyQueryHookResult = ReturnType<typeof useProductGroupLazyQuery>;
export type ProductGroupQueryResult = Apollo.QueryResult<ProductGroupQuery, ProductGroupQueryVariables>;
export const PatchProductGroupDocument = gql`
    mutation PatchProductGroup($input: PatchProductGroupGraphqlInputType!) {
  adminPatchProductGroup(input: $input) {
    id
  }
}
    `;
export type PatchProductGroupMutationFn = Apollo.MutationFunction<PatchProductGroupMutation, PatchProductGroupMutationVariables>;

/**
 * __usePatchProductGroupMutation__
 *
 * To run a mutation, you first call `usePatchProductGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePatchProductGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [patchProductGroupMutation, { data, loading, error }] = usePatchProductGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePatchProductGroupMutation(baseOptions?: Apollo.MutationHookOptions<PatchProductGroupMutation, PatchProductGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PatchProductGroupMutation, PatchProductGroupMutationVariables>(PatchProductGroupDocument, options);
      }
export type PatchProductGroupMutationHookResult = ReturnType<typeof usePatchProductGroupMutation>;
export type PatchProductGroupMutationResult = Apollo.MutationResult<PatchProductGroupMutation>;
export type PatchProductGroupMutationOptions = Apollo.BaseMutationOptions<PatchProductGroupMutation, PatchProductGroupMutationVariables>;
export const BrandsInProductGroupDocument = gql`
    query BrandsInProductGroup($filter: AdminListBrandsPageQueryFilter) {
  adminBrands(filter: $filter) {
    edges {
      node {
        name
        id
      }
    }
  }
}
    `;

/**
 * __useBrandsInProductGroupQuery__
 *
 * To run a query within a React component, call `useBrandsInProductGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandsInProductGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandsInProductGroupQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useBrandsInProductGroupQuery(baseOptions?: Apollo.QueryHookOptions<BrandsInProductGroupQuery, BrandsInProductGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandsInProductGroupQuery, BrandsInProductGroupQueryVariables>(BrandsInProductGroupDocument, options);
      }
export function useBrandsInProductGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandsInProductGroupQuery, BrandsInProductGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandsInProductGroupQuery, BrandsInProductGroupQueryVariables>(BrandsInProductGroupDocument, options);
        }
export type BrandsInProductGroupQueryHookResult = ReturnType<typeof useBrandsInProductGroupQuery>;
export type BrandsInProductGroupLazyQueryHookResult = ReturnType<typeof useBrandsInProductGroupLazyQuery>;
export type BrandsInProductGroupQueryResult = Apollo.QueryResult<BrandsInProductGroupQuery, BrandsInProductGroupQueryVariables>;
export const CreateTemporaryProductDocument = gql`
    mutation CreateTemporaryProduct($input: CreateTemporaryProductGraphqlInput!) {
  adminCreateTemporaryProduct(input: $input) {
    temporaryProduct {
      id
    }
  }
}
    `;
export type CreateTemporaryProductMutationFn = Apollo.MutationFunction<CreateTemporaryProductMutation, CreateTemporaryProductMutationVariables>;

/**
 * __useCreateTemporaryProductMutation__
 *
 * To run a mutation, you first call `useCreateTemporaryProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTemporaryProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTemporaryProductMutation, { data, loading, error }] = useCreateTemporaryProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTemporaryProductMutation(baseOptions?: Apollo.MutationHookOptions<CreateTemporaryProductMutation, CreateTemporaryProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTemporaryProductMutation, CreateTemporaryProductMutationVariables>(CreateTemporaryProductDocument, options);
      }
export type CreateTemporaryProductMutationHookResult = ReturnType<typeof useCreateTemporaryProductMutation>;
export type CreateTemporaryProductMutationResult = Apollo.MutationResult<CreateTemporaryProductMutation>;
export type CreateTemporaryProductMutationOptions = Apollo.BaseMutationOptions<CreateTemporaryProductMutation, CreateTemporaryProductMutationVariables>;
export const UpdateTemporaryProductDocument = gql`
    mutation UpdateTemporaryProduct($input: UpdateTemporaryProductGraphqlInput!) {
  adminUpdateTemporaryProduct(input: $input) {
    temporaryProduct {
      id
    }
  }
}
    `;
export type UpdateTemporaryProductMutationFn = Apollo.MutationFunction<UpdateTemporaryProductMutation, UpdateTemporaryProductMutationVariables>;

/**
 * __useUpdateTemporaryProductMutation__
 *
 * To run a mutation, you first call `useUpdateTemporaryProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTemporaryProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTemporaryProductMutation, { data, loading, error }] = useUpdateTemporaryProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTemporaryProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTemporaryProductMutation, UpdateTemporaryProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTemporaryProductMutation, UpdateTemporaryProductMutationVariables>(UpdateTemporaryProductDocument, options);
      }
export type UpdateTemporaryProductMutationHookResult = ReturnType<typeof useUpdateTemporaryProductMutation>;
export type UpdateTemporaryProductMutationResult = Apollo.MutationResult<UpdateTemporaryProductMutation>;
export type UpdateTemporaryProductMutationOptions = Apollo.BaseMutationOptions<UpdateTemporaryProductMutation, UpdateTemporaryProductMutationVariables>;
export const TemporaryProductDocument = gql`
    query TemporaryProduct($adminTemporaryProductId: Int!) {
  adminTemporaryProduct(id: $adminTemporaryProductId) {
    json
    id
  }
}
    `;

/**
 * __useTemporaryProductQuery__
 *
 * To run a query within a React component, call `useTemporaryProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemporaryProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemporaryProductQuery({
 *   variables: {
 *      adminTemporaryProductId: // value for 'adminTemporaryProductId'
 *   },
 * });
 */
export function useTemporaryProductQuery(baseOptions: Apollo.QueryHookOptions<TemporaryProductQuery, TemporaryProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TemporaryProductQuery, TemporaryProductQueryVariables>(TemporaryProductDocument, options);
      }
export function useTemporaryProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TemporaryProductQuery, TemporaryProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TemporaryProductQuery, TemporaryProductQueryVariables>(TemporaryProductDocument, options);
        }
export type TemporaryProductQueryHookResult = ReturnType<typeof useTemporaryProductQuery>;
export type TemporaryProductLazyQueryHookResult = ReturnType<typeof useTemporaryProductLazyQuery>;
export type TemporaryProductQueryResult = Apollo.QueryResult<TemporaryProductQuery, TemporaryProductQueryVariables>;
export const DeleteTemporaryProductDocument = gql`
    mutation DeleteTemporaryProduct($adminDeleteTemporaryProductId: Int!) {
  adminDeleteTemporaryProduct(id: $adminDeleteTemporaryProductId) {
    id
  }
}
    `;
export type DeleteTemporaryProductMutationFn = Apollo.MutationFunction<DeleteTemporaryProductMutation, DeleteTemporaryProductMutationVariables>;

/**
 * __useDeleteTemporaryProductMutation__
 *
 * To run a mutation, you first call `useDeleteTemporaryProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTemporaryProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTemporaryProductMutation, { data, loading, error }] = useDeleteTemporaryProductMutation({
 *   variables: {
 *      adminDeleteTemporaryProductId: // value for 'adminDeleteTemporaryProductId'
 *   },
 * });
 */
export function useDeleteTemporaryProductMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTemporaryProductMutation, DeleteTemporaryProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTemporaryProductMutation, DeleteTemporaryProductMutationVariables>(DeleteTemporaryProductDocument, options);
      }
export type DeleteTemporaryProductMutationHookResult = ReturnType<typeof useDeleteTemporaryProductMutation>;
export type DeleteTemporaryProductMutationResult = Apollo.MutationResult<DeleteTemporaryProductMutation>;
export type DeleteTemporaryProductMutationOptions = Apollo.BaseMutationOptions<DeleteTemporaryProductMutation, DeleteTemporaryProductMutationVariables>;